window._mode='front';window._protocol='https://';window._domain='camping.ribeauville.fr';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/prima/';window._api='/api/v2/';
import cwException from 'components/exception.js';
import { Fetch } from 'components/fetch.js';
import { Popover } from 'bootstrap';

window.addEventListener("DOMContentLoaded", (event) =>
{
    try
    {
        if (document.querySelectorAll('.cw-widget.blog.calendar').length > 0)
        {
            document.querySelectorAll('.cw-widget.blog.calendar').forEach(e =>
            {
                const id_category = parseInt(e.getAttribute('data-category'));
                const flag = e.getAttribute('data-flag');
                const day_format = e.getAttribute('data-day_format');
                const month = parseInt(e.getAttribute('data-month'));
                const year = parseInt(e.getAttribute('data-year'));
                get_calendar(month, year, id_category, flag, day_format);
            });
        }
        document.querySelectorAll('.blog-widget-calendar-nav-link').forEach(e =>
        {
            e.addEventListener('click', event =>
            {
                event.preventDefault();
                const id_category = parseInt(e.dataset.category);
                const flag = e.dataset.flag;
                const day_format = e.dataset.day_format;
                const currentMonth = parseInt(e.dataset.month);
                const currentYear = parseInt(e.dataset.year);
                let month = currentMonth;
                let year = currentYear;
                if (e.classList.contains('next'))
                {
                    if (currentMonth == 12)
                    {
                        month = 1;
                        year = currentYear + 1;
                    }
                    else
                    {
                        month = currentMonth + 1;
                    }
                }
                else
                {
                    if (currentMonth == 1)
                    {
                        month = 12;
                        year = currentYear - 1;
                    }
                    else
                    {
                        month = currentMonth - 1;
                    }
                }
                get_calendar(month, year, id_category, flag, day_format);

                return false;
            });
        });
    }
    catch(e)
    {
        throw new cwException(e);
    }
});


async function get_calendar(month, year, id_category, flag, day_format)
{
    try
    {

        const res = await Fetch(`${_api}blog/calendar/${id_category}/${month}/${year}/?flag=${flag}&day_format=${day_format}`, {
			method: 'GET'
		});
        const msg = await res.json();
        if (res.status != 200)
        {
            throw new cwException(msg);
        }

        if (document.querySelector('.blog-widget-calendar-calendar'))
        {
            document.querySelector('.blog-widget-calendar-calendar').remove();
        }

        const prevButton = document.querySelector(`#blog-widget-calendar-${id_category}-${flag} .prev`);
        prevButton.setAttribute('data-month', msg.month);
        prevButton.setAttribute('data-year', msg.year);

        const nextButton = document.querySelector(`#blog-widget-calendar-${id_category}-${flag} .next`);
        nextButton.setAttribute('data-month', msg.month);
        nextButton.setAttribute('data-year', msg.year);

        const monthLabel = document.querySelector(`#blog-widget-calendar-${id_category}-${flag} span.blog-widget-calendar-nav-month`);
        monthLabel.innerHTML = msg.label_month;

        const yearLabel = document.querySelector(`#blog-widget-calendar-${id_category}-${flag} span.blog-widget-calendar-nav-year`);
        yearLabel.innerHTML = msg.year;

        document.querySelector(`#blog-widget-calendar-${id_category}-${flag}`).insertAdjacentHTML('beforeend', msg.calendar);

        const popoverTriggerList = document.querySelectorAll('.blog-widget-calendar-calendar [data-bs-toggle="popover"]');
        [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl))

    }
    catch (e)
    {
        throw new cwException(e);
    }
}